import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
  Tooltip,
  ModalHeader,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import myma_logo from './../../assets/myma_logo.png';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import {
  postAPI_ResetPassword,
  API_PAGE_CONTENT,
  postAPI_VerifyForgotPassword,
} from '../../constants/APIs';
import PasswordStrengthBar from 'react-password-strength-bar';
import { NotificationManager } from '../../components/common/react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import queryString from 'query-string';
import parse from 'html-react-parser';
export default class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      reason: 'ForgotFlow',
      password: '',
      creator: 'user',
      formShow: true,
      loginbutton: false,
      loading: false,
      message: '',
      process: false,
      passwordStrength: '',
      isShow: false,
      tooltip: false,
      confirmPassword: '',
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      token: '',
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const token = values.data;
    this.setState({ token });
    console.log('120', token);
    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_VerifyForgotPassword}`,
      data: { data: token },
    }).then(
      (res) => {
        this.setState({ id: res.data.id });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );

    AxiosPublicAPI({
      method: 'get',
      url: `${API_PAGE_CONTENT}?provider=${this.extractProvider()}&page=reset-password`,
    }).then(
      (res) => {
        if (
          res.data.contentArea1 !== undefined &&
          res.data.contentArea1 !== null &&
          res.data.contentArea1 !== ''
        )
          this.setState({
            contentArea1: res.data.contentArea1,
          });

        if (
          res.data.contentArea2 !== undefined &&
          res.data.contentArea2 !== null &&
          res.data.contentArea2 !== ''
        )
          this.setState({
            contentArea2: res.data.contentArea2,
          });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  extractProvider() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      return 5;
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      return 1;
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      return 1;
    } else if (window.location.hostname.toLowerCase().startsWith('app.myma.ai'))
      return 1;
    else return 1;
  }

  handleChangePassword = (password) => {
    this.setState({
      password: password.target.value,
    });
  };

  onUserResetPassword() {
    let data = {
      reason: 'ForgotFlow',
      password: this.state.password,
      creator: 'user',
      data: this.state.token,
    };

    var passwordPattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;

    if (
      this.state.password.length >= 12 &&
      this.state.password.length <= 16 &&
      /(?=.*[A-Z])/.test(this.state.password) &&
      /(?=.*[a-z])/.test(this.state.password) &&
      /(?=.*[0-9])/.test(this.state.password) &&
      /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password)
    ) {
      if (this.state.password !== this.state.confirmPassword) {
        this.setState({
          message: 'Password and confirm password are not matched.',
        });
        this.setState({ isShow: true });
      } else {
        this.setState({ process: true, loading: true });
        this.setState({ process: true, loading: true });
        AxiosPublicAPI({
          method: 'put',
          url: `${postAPI_ResetPassword}/${this.state.id}/change-password`,

          data: data,
        }).then(
          (res) => {
            this.setState({
              formShow: false,
              loginbutton: true,
            });
            // NotificationManager.success(--
            //   'Password Reset Successfully',
            //   'Password Reset Success',
            //   3000,
            //   null,
            //   null,
            //   'success'
            // );
            this.setState({ loading: false });
          },
          (error) => {
            console.log('eee.data', error.data);
          }
        );
      }
    } else {
      this.setState({
        message:
          'Password length must be in between of 12 to 16 character and its must have atleast 1 upper case, 1 lower case, 1 digit and 1 special character.',
      });
      this.setState({ isShow: true });
    }
  }
  onGoLogin() {
    if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.concierge.synxis.com')
    ) {
      window.location.href = 'https://app.concierge.synxis.com';
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.bookmebob.com')
    ) {
      window.location.href = 'https://app.bookmebob.com';
    } else if (
      window.location.hostname
        .toLowerCase()
        .startsWith('app.devtest.bookmebob.com')
    ) {
      window.location.href = 'https://app.devtest.bookmebob.com';
    } else if (
      window.location.hostname.toLowerCase().startsWith('app.devtest.myma.ai')
    ) {
      window.location.href = 'https://app.devtest.myma.ai';
    } else if (window.location.hostname.toLowerCase().startsWith('app.myma.ai'))
      window.location.href = 'https://app.myma.ai';
    else window.location.href = 'https://app.bookmebob.com';
  }

  handleChangeConfirmPassword = (password) => {
    this.setState({
      confirmPassword: password.target.value,
    });
  };
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };

  toggleConfirmPasswordVisibility = () => {
    this.setState((prevState) => ({
      isConfirmPasswordVisible: !prevState.isConfirmPasswordVisible,
    }));
  };

  render() {
    return (
      <Fragment>
        <Row className="h-100" style={{ width: '100%' }}>
          <Colxx xxs="12" md="10" className="mx-auto my-auto">
            <Card className="auth-card">
              {this.state?.contentArea1 ? (
                parse(this.state?.contentArea1)
              ) : (
                <div className="position-relative image-side">
                  <p className="text-white h2">
                    <b>Empowerment</b> starts here
                  </p>
                  <p className="white mb-0">
                    Please use your e-mail to reset your password.
                  </p>
                </div>
              )}
              <div className="form-side">
                {!this.state.process && (
                  <Fragment>
                    <NavLink to={`/`} className="white">
                      {this.state?.contentArea2 ? (
                        parse(this.state?.contentArea2)
                      ) : (
                        <span className="logo-single">
                          {' '}
                          <img src={myma_logo} width="150" height="100" />{' '}
                        </span>
                      )}
                    </NavLink>
                    <CardTitle
                      className="mb-4"
                      style={{
                        display: this.state.formShow ? 'block' : 'none',
                      }}
                    >
                      Reset Password
                    </CardTitle>
                    <div className="m-2">
                      <h6>Your password must contain </h6>
                      <ul className="ml-3">
                        <li className="mb-2">Atleast 12 Characters.</li>
                        <li className="mb-2">Atleast one upper case letter.</li>
                        <li className="mb-2">Atleast one lower case letter.</li>
                        <li className="mb-2">Atleast one number.</li>
                        <li className="mb-2">
                          Atleast one of the following symbols
                          (?=.*[@#$%^&-+=()]).
                        </li>
                      </ul>
                    </div>
                    <Form
                      style={{
                        display: this.state.formShow ? 'block' : 'none',
                      }}
                    >
                      <Label
                        className="form-group has-float-label mb-4"
                        id="Tooltip"
                      >
                        <Input
                          className="input_sty"
                          type={
                            this.state.isPasswordVisible ? 'text' : 'password'
                          }
                          onChange={this.handleChangePassword}
                        />
                        <IntlMessages id="user.newpassword" />
                        <FontAwesomeIcon
                          icon={
                            this.state.isPasswordVisible ? faEyeSlash : faEye
                          } // Toggle between eye and eye-slash
                          onClick={this.togglePasswordVisibility} // Call toggle visibility function
                          style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            right: '10px',
                            top: '10px',
                          }}
                        />
                      </Label>
                      <Tooltip
                        placement={'right'}
                        isOpen={this.state.tooltip}
                        target={'Tooltip'}
                        toggle={() =>
                          this.setState((prevState) => ({
                            tooltip: !prevState.tooltip,
                          }))
                        }
                      >
                        <p
                          className="text-start"
                          style={{
                            color: `${
                              this.state.password.length >= 12 ? 'green' : 'red'
                            }`,
                          }}
                        >
                          <img
                            src="https://webchat.bookmebob.com/res/close_cross.png"
                            width={10}
                            height={10}
                          ></img>
                          <span className="ml-2">
                            Have atleast 12 characters
                          </span>
                        </p>
                        <p
                          className="text-start"
                          style={{
                            color: `${
                              /(?=.*[A-Z])/.test(this.state.password)
                                ? 'green'
                                : 'red'
                            }`,
                          }}
                        >
                          <img
                            src="https://webchat.bookmebob.com/res/close_cross.png"
                            width={10}
                            height={10}
                          ></img>
                          <span className="ml-2">
                            Have atleast one upper case character
                          </span>
                        </p>
                        <p
                          className="text-start"
                          style={{
                            color: `${
                              /(?=.*[a-z])/.test(this.state.password)
                                ? 'green'
                                : 'red'
                            }`,
                          }}
                        >
                          <img
                            src="https://webchat.bookmebob.com/res/close_cross.png"
                            width={10}
                            height={10}
                          ></img>
                          <span className="ml-2">
                            Have atleast one lower case character
                          </span>
                        </p>
                        <p
                          className="text-start"
                          style={{
                            color: `${
                              /(?=.*[0-9])/.test(this.state.password)
                                ? 'green'
                                : 'red'
                            }`,
                          }}
                        >
                          <img
                            src="https://webchat.bookmebob.com/res/close_cross.png"
                            width={10}
                            height={10}
                          ></img>
                          <span className="ml-2">Have atleast one number</span>
                        </p>
                        <p
                          className="text-start"
                          style={{
                            color: `${
                              /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(
                                this.state.password
                              )
                                ? 'green'
                                : 'red'
                            }`,
                          }}
                        >
                          <img
                            src="https://webchat.bookmebob.com/res/close_cross.png"
                            width={10}
                            height={10}
                          ></img>
                          <span className="ml-2">
                            Have atleast one special character
                          </span>
                        </p>
                      </Tooltip>
                      {this.state.password !== '' && (
                        <div className="">
                          <PasswordStrengthBar
                            minLength={12}
                            password={this.state.password}
                          ></PasswordStrengthBar>
                        </div>
                      )}
                      <Label className="form-group has-float-label my-4">
                        <Input
                          className="input_sty"
                          type={
                            this.state.isConfirmPasswordVisible
                              ? 'text'
                              : 'password'
                          }
                          onChange={this.handleChangeConfirmPassword}
                        />
                        <IntlMessages id="user.newpasswordagain" />
                        <FontAwesomeIcon
                          icon={
                            this.state.isConfirmPasswordVisible
                              ? faEyeSlash
                              : faEye
                          } // Toggle between eye and eye-slash
                          onClick={this.toggleConfirmPasswordVisibility} // Call toggle visibility function
                          style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            right: '10px',
                            top: '10px',
                          }}
                        />
                      </Label>
                      <div className="d-flex justify-content-end align-items-center">
                        <Button
                          color="primary"
                          className="btn-shadow"
                          size="lg"
                          onClick={() => this.onUserResetPassword()}
                        >
                          <IntlMessages id="user.reset-password-button" />
                        </Button>
                      </div>
                    </Form>
                  </Fragment>
                )}
                {this.state.process &&
                  (this.state.loading ? (
                    <div className="text-center">
                      <Spinner color="primary" className="mb-1" />
                      <p>Your request is in progress</p>
                    </div>
                  ) : (
                    <div className="text-center">
                      <h2 className="mb-5">Password successfully reset</h2>
                      <p className="mb-2">
                        You have successfully reset your password
                      </p>
                      <a>
                        {' '}
                        <div
                          className="text-primary text-small font-weight-medium d-none d-sm-block"
                          onClick={() => this.onGoLogin()}
                        >
                          Return to log in screen
                        </div>{' '}
                      </a>
                    </div>
                  ))}
                {/* {this.state.loginbutton === true && (
                <Form>
                  <Button
                    onClick={() => this.onGoLogin()}
                    color="primary"
                    size="lg"
                    className="btn-shadow"
                  >
                    <IntlMessages id="user.login-button" />
                  </Button>
                </Form>
              )} */}
              </div>
            </Card>
          </Colxx>
        </Row>
        <Modal
          isOpen={this.state.isShow}
          toggle={() => this.setState({ isShow: !this.state.isShow })}
        >
          <ModalHeader
            toggle={() => this.setState({ isShow: !this.state.isShow })}
          >
            Password
          </ModalHeader>
          <ModalBody>
            <h6 className="m-2">{this.state.message}</h6>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => this.setState({ isShow: !this.state.isShow })}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
